import { render, staticRenderFns } from "./brankaddorupd.vue?vue&type=template&id=6bc0243b&scoped=true"
import script from "./brankaddorupd.vue?vue&type=script&lang=js"
export * from "./brankaddorupd.vue?vue&type=script&lang=js"
import style0 from "./brankaddorupd.vue?vue&type=style&index=0&id=6bc0243b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0243b",
  null
  
)

export default component.exports